import { createContext } from "react";
var CBContext = createContext({
    isAcceptAllChecked: false,
    isRefuseAllChecked: false,
});
export default CBContext;
